import request from '../../utils/request'

export default {
  getAll: data => request({
    url: '/api/services/app/PaymentCategory/GetAll',
    method: 'get',
    params: data
  }),
  get: data => request({
    url: '/api/services/app/PaymentCategory/Get',
    method: 'get',
    params: data
  }),
  getForEdit: data => request({
     url: '/api/services/app/PaymentCategory/GetForEdit',
     method: 'get',
     params: data
  }),
  create: data => request({
    url: '/api/services/app/PaymentCategory/Create',
    method: 'post',
    data: data
  }),
  update: data => request({
    url: '/api/services/app/PaymentCategory/Update',
    method: 'put',
    data: data
  }),
  delete: function(data) {
    return request({
      url: '/api/services/app/PaymentCategory/delete',
      method: 'delete',
      params: data
    })
  }
}
